// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useRouter } from 'next/navigation';

import { ROUTE_CHANGE_START_EVENT } from './constants';

import { useCurrentLocation } from '@/modules/location/useCurrentLocation';
import { replaceUsernameInPath } from '@/modules/routing/helpers';

export function useExtendedRouter() {
  const router = useRouter();
  const { localisedRoutes, defaultLocation, location } = useCurrentLocation();

  function extendedRouterPush(...args: Parameters<typeof router.push>) {
    document.dispatchEvent(new CustomEvent(ROUTE_CHANGE_START_EVENT));
    const [href, options] = args;
    const formattedHref = replaceUsernameInPath(href);

    const isLocalisedRoute = localisedRoutes.some((route) => {
      const strippedHref = formattedHref
        .split('/')
        .filter((item) => item.length)
        .shift();
      return strippedHref === route;
    });

    let locale: string = isLocalisedRoute ? location : defaultLocation;
    if (!formattedHref.startsWith('/')) {
      locale += '/';
    }

    const localisedHref =
      locale === defaultLocation ? formattedHref : `/${locale}${formattedHref}`;
    return router.push(localisedHref, options);
  }

  return { ...router, push: extendedRouterPush };
}
